import { createSelector } from 'reselect'
import { State } from 'index'

const storeTimesaleSelector = (state: State) => state.storeTimesale

export const getStoreTimesale = createSelector([storeTimesaleSelector], (state) => state.storeTimesale)
